import React from "react";
import { MethodIcon } from "./MethodIcon";
import { ReactComponent as InteracIcon } from "features/wallet/assets/interac-small.svg";

import * as styles from "./InteracMethodIcon.module.scss";

export const InteracMethodIcon = () => (
  <MethodIcon className={styles.interacMethodIcon}>
    <InteracIcon />
  </MethodIcon>
);
